export const collectionToArray = (collection, protectedKeys = []) => {
  if (!collection || typeof collection === "undefined") return []

  let arr = []
  for (const [key, value] of Object.entries(collection)) {
    arr.push({ id: key, ...value })
  }

  if (protectedKeys.length < 1) return arr

  return arr.map(item => {
    protectedKeys.forEach(protectedKey => delete item[protectedKey])
    return item
  })
}